import React from 'react';
import PropTypes from 'prop-types';
import {
  SimpleModal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from '@ami/react/core';
import { InvisibleSubmit } from '@ami/react/core';
import { makeValidable } from '@ami/react/core';
import { formatPrice } from '../../../quotes/priceFormatter';
import { Input } from '@ami/react/core';
import { ProductOptionSearchItem } from '../../../products/productOption';

const priceValueClassName = 'quote-price-value';

const ProductPrices = ({
  quoteProduct,
  updateQuoteProduct,
  msrpMarkupPercentage,
}) => {
  return (
    <div key={quoteProduct.productId}>
      {quoteProduct.originalDNetPrice === undefined && (
        <div className="row">
          <h5 className="col-6">Base Price</h5>
          <div className="col-2">
            <button
              type="button"
              className="btn btn-link ps-0 pt-0 pe-2 pb-2 m-0"
              onClick={(e) => {
                e.preventDefault();
                const copy = quoteProduct.clone();
                copy.addOverridePrice();
                updateQuoteProduct(copy);
              }}
            >
              Add
            </button>
          </div>
          <h5 className="col-2 text-end">{formatPrice(quoteProduct.msrp)}</h5>
          <h5 className="col-2 text-end">
            {formatPrice(quoteProduct.dNetPrice)}
          </h5>
        </div>
      )}
      {quoteProduct.originalDNetPrice !== undefined && (
        <div className="row">
          <h5 className="col-6">Base Price</h5>
          <div className="col-2">
            <button
              type="button"
              className="btn btn-link ps-0 pt-0 pe-2 pb-2 m-0"
              onClick={(e) => {
                e.preventDefault();
                const copy = quoteProduct.clone();
                copy.removeOverridePrice(msrpMarkupPercentage);
                updateQuoteProduct(copy);
              }}
            >
              Remove
            </button>
          </div>
          <h5 className={'col-2 text-end'}>{formatPrice(quoteProduct.msrp)}</h5>
          <h5 className={'col-2 text-end ' + priceValueClassName}>
            {
              <Input
                prependValue="$"
                id="productPrice"
                className="inline-input"
                type="number"
                step="0.01"
                min="0"
                value={quoteProduct.dNetPrice}
                onChange={(e) => {
                  const copy = quoteProduct.clone();
                  copy.updateOverridePrice(
                    e.target.value,
                    msrpMarkupPercentage
                  );
                  updateQuoteProduct(copy);
                }}
                style={{ textAlign: 'right' }}
              />
            }
          </h5>
        </div>
      )}
    </div>
  );
};

const ProductOptions = ({
  quoteProduct,
  updateQuoteProduct,
  msrpMarkupPercentage,
  productOptions,
}) => {
  return quoteProduct.productOptions.map((item) => {
    if (
      item.productOptionId !== null &&
      item.productOptionId !== undefined &&
      item.productOptionId !== ''
    ) {
      const productOption = productOptions.find(
        (x) => x.id === item.productOptionId
      );
      return (
        <div key={item.productOptionId}>
          {item.originalDNetPrice === undefined && (
            <div className="row">
              <h5 className="col-6">{productOption.name}</h5>
              <div className="col-2">
                <button
                  type="button"
                  className="btn btn-link ps-0 pt-0 pe-2 pb-2 m-0"
                  onClick={(e) => {
                    e.preventDefault();
                    const copy = quoteProduct.clone();
                    const productOption = copy.productOptions.find(
                      (x) => x.productOptionId === item.productOptionId
                    );
                    productOption.addOverridePrice();
                    updateQuoteProduct(copy);
                  }}
                >
                  Add
                </button>
              </div>
              <h5 className="col-2 text-end">{formatPrice(item.msrp)}</h5>
              <h5 className="col-2 text-end">{formatPrice(item.dNetPrice)}</h5>
            </div>
          )}
          {item.originalDNetPrice !== undefined && (
            <div className="row">
              <h5 className="col-6">{productOption.name}</h5>
              <div className="col-2">
                <button
                  type="button"
                  className="btn btn-link ps-0 pt-0 pe-2 pb-2 m-0"
                  onClick={(e) => {
                    e.preventDefault();
                    const copy = quoteProduct.clone();
                    const productOption = copy.productOptions.find(
                      (x) => x.productOptionId === item.productOptionId
                    );
                    productOption.removeOverridePrice(msrpMarkupPercentage);
                    updateQuoteProduct(copy);
                  }}
                >
                  Remove
                </button>
              </div>
              <h5 className="col-2 text-end">
                {formatPrice(
                  quoteProduct.productOptions.find(
                    (x) => x.productOptionId === item.productOptionId
                  ).msrp
                )}
              </h5>
              <h5 className={'col-2 text-end ' + priceValueClassName}>
                {
                  <Input
                    prependValue="$"
                    id={item.name}
                    className="inline-input"
                    type="number"
                    step="0.01"
                    min="0"
                    value={item.dNetPrice}
                    onChange={(e) => {
                      const copy = quoteProduct.clone();
                      const productOption = copy.productOptions.find(
                        (x) => x.productOptionId === item.productOptionId
                      );
                      productOption.updateOverridePrice(
                        e.target.value,
                        msrpMarkupPercentage
                      );
                      updateQuoteProduct(copy);
                    }}
                    style={{ textAlign: 'right' }}
                  />
                }
              </h5>
            </div>
          )}
        </div>
      );
    } else {
      return null;
    }
  });
};

const FormData = makeValidable(
  ({
    quoteProduct,
    save,
    updateQuoteProduct,
    msrpMarkupPercentage,
    productOptions,
  }) => {
    return (
      <form className="quoteProduct" onSubmit={save}>
        <div className="row justify-content-end">
          <div className="col-6 font-weight-bold">Item</div>
          <div className="col-2 font-weight-bold">Override</div>
          <div className="col-2 font-weight-bold text-end">MSRP</div>
          <div className="col-2 font-weight-bold text-end">D. NET</div>
        </div>
        <ProductPrices
          quoteProduct={quoteProduct}
          updateQuoteProduct={updateQuoteProduct}
          msrpMarkupPercentage={msrpMarkupPercentage}
        />
        <ProductOptions
          quoteProduct={quoteProduct}
          updateQuoteProduct={updateQuoteProduct}
          msrpMarkupPercentage={msrpMarkupPercentage}
          productOptions={productOptions}
        />
        <InvisibleSubmit />
      </form>
    );
  }
);

export default class ReviewQuoteProductOverridePricingModal extends React.Component {
  constructor(props) {
    super(props);
    this.formDataRef = React.createRef();
  }

  state = {
    show: false,
    showValidations: false,
    quoteProduct: null,
  };

  static propTypes = {
    onUpdateProduct: PropTypes.func.isRequired,
    msrpMarkupPercentage: PropTypes.number.isRequired,
    productOptions: PropTypes.arrayOf(
      PropTypes.instanceOf(ProductOptionSearchItem)
    ).isRequired,
  };

  overridePricingFor(quoteProduct) {
    this.setState({
      show: true,
      showValidations: false,
      quoteProduct,
    });
  }

  updateQuoteProduct = (quoteProduct) => {
    this.setState({ quoteProduct });
  };

  hide = () => this.setState({ show: false });

  save = (e) => {
    if (e) e.preventDefault();
    this.setState({ showValidations: true }, () => {
      if (!this.formDataRef.current.isValid()) {
        return;
      }

      const quoteProduct = this.state.quoteProduct;
      this.props.onUpdateProduct(quoteProduct);
      this.hide();
    });
  };

  render() {
    const { quoteProduct, show, showValidations } = this.state;
    if (!show || !quoteProduct) return null;
    return (
      <SimpleModal show={show} size="lg">
        <ModalHeader title={'Product Pricing for ' + quoteProduct.groupName} />
        <ModalBody>
          <FormData
            quoteProduct={quoteProduct}
            save={this.save}
            updateQuoteProduct={this.updateQuoteProduct}
            ref={this.formDataRef}
            showValidations={showValidations}
            overridePricingFor={this.overridePricingFor}
            msrpMarkupPercentage={this.props.msrpMarkupPercentage}
            productOptions={this.props.productOptions}
          />
        </ModalBody>
        <ModalFooter>
          <button className="btn btn-secondary" onClick={this.hide}>
            Cancel
          </button>
          <button className="btn btn-primary" onClick={this.save}>
            Save
          </button>
        </ModalFooter>
      </SimpleModal>
    );
  }
}
